import { SalesDespatchItemProcessingReport } from './sales-despatch-item-processing-report';

export interface SalesDespatchItemInvoiceReport {
  stockNo: string;
  productKey: string;
  productDescription: string;
  batchNo: string;
  customerProduct: string;
  grossQuantity: number;
  nettQuantity: number;
  price: number;
  value: number;
  balanceToFollow: string;
  unitOfMeasure: string;
  noOfItems: number;
  currencySymbol: string;

  salesDespatchItemProcessings: SalesDespatchItemProcessingReport[];
}
